import { Component, EventEmitter, Input, Output } from '@angular/core'
import {
  openCloseWidget,
  openCloseWidgetHeader,
  openCloseWidgetContent,
} from '../../utils/animations'
import { ContextService } from '../../services'

@Component({
  standalone: false,
  selector: 'app-list-widget',
  templateUrl: './list-widget.component.html',
  styleUrls: ['./list-widget.component.scss'],
  animations: [openCloseWidget, openCloseWidgetHeader, openCloseWidgetContent],
})
export class ListWidgetComponent {
  private _data = []

  get data(): any[] {
    return this._data
  }

  @Input()
  set data(value: any[]) {
    this._data = value
    if (Array.isArray(this._data) && this._data.length > this.maxResults) {
      this.hasMoreResults = true
    }
  }

  @Input() title = ''
  @Input() isMultiple = false
  @Input() unit = ''
  @Input() isRanking = true
  @Input() maxResults = 10
  @Input() labelKey = 'category'
  @Input() labels = []
  @Input() stats
  widgetCollapsed = false
  hasMoreResults = false
  @Input() showViewFullTable = false
  @Output() onClickViewFullTable = new EventEmitter()

  get referenceData() {
    const data = this.isMultiple ? this._data[0] || [] : this._data
    return (data || []).slice(0, this.maxResults + 1)
  }

  get comparisonData() {
    return this.isMultiple
      ? this._data[1].slice(0, this.maxResults + 1) || []
      : null
  }

  get isVisitsAvailable() {
    return this.context.isVisitsAvailable()
  }

  get keyIndicatorLabel() {
    return this.context.keyIndicator.label.toLowerCase()
  }

  constructor(private context: ContextService) {}

  toggleWidget() {
    this.widgetCollapsed = !this.widgetCollapsed
  }

  getValue(elem) {
    if (this.unit === '%') {
      return elem.perc
    } else {
      return elem.value || elem[this.context.keyIndicator.value] || 0
    }
  }

  getPercentageTotalValue(elem) {
    return (this.getValue(elem) / this.stats) * 100
  }

  openPopup() {
    this.onClickViewFullTable.emit()
  }
}
